// extracted by mini-css-extract-plugin
export default {"no-data-container":"list_no-data-container__bIQPt","not-found-title":"list_not-found-title__L9yTJ","float-btn":"list_float-btn__fjT4q"};